// 치과 발송 보류 경고 3종(대표전화·치과명 미등록, 치과명 금지어) — 공용 (2026-10-08 알림 파트, 기획서 §4-1 A-1 "공용 컴포넌트로 추출")
//   문구는 ClinicRecalls.js 상단 경고와 같다. blockers = clinicSendBlockers(res) 결과 ['phone'|'name'|'banned']
import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneOff, Building2, ShieldAlert } from 'lucide-react';

const warnBox = { background: '#fffbeb', border: '1px solid #fcd34d', color: '#92400e', borderRadius: 8, padding: '10px 12px', fontSize: 13, lineHeight: 1.6, marginBottom: 12, display: 'flex', alignItems: 'flex-start', gap: 8 };
const warnLink = { color: '#b45309', fontWeight: 600, textDecoration: 'underline' };

function RecallSendBlockers({ blockers }) {
    const list = Array.isArray(blockers) ? blockers : [];
    if (!list.length) return null;
    return (
        <>
            {list.includes('phone') && (
                <div style={warnBox}>
                    <PhoneOff size={16} style={{ flexShrink: 0, marginTop: 2 }} />
                    <div><b>{'대표전화가 등록되지 않아 안내가 발송되지 않습니다.'}</b>{' '}<Link to="/profile" style={warnLink}>{'설정 › 프로필'}</Link>{'에서 대표전화를 등록하면 예정일부터 발송됩니다.'}</div>
                </div>
            )}
            {list.includes('name') && (
                <div style={warnBox}>
                    <Building2 size={16} style={{ flexShrink: 0, marginTop: 2 }} />
                    <div><b>{'치과 이름이 등록되지 않아 안내가 발송되지 않습니다.'}</b>{' '}<Link to="/profile" style={warnLink}>{'설정 › 프로필'}</Link>{'에서 치과 이름(업체명)을 등록하면 예정일부터 발송됩니다.'}</div>
                </div>
            )}
            {list.includes('banned') && (
                <div style={warnBox}>
                    <ShieldAlert size={16} style={{ flexShrink: 0, marginTop: 2 }} />
                    <div><b>{'치과 이름에 사용할 수 없는 표현이 있어 안내가 보류됩니다.'}</b>{' 덴탈클러스터에 문의해 주세요.'}</div>
                </div>
            )}
        </>
    );
}

export default RecallSendBlockers;
